
import { Vue } from "vue-class-component";

export default class FileChart extends Vue {}
